import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { getAddresses, deleteAddress, createAddress, updateAddress } from "../../services/address";
import { toast } from "react-toastify";
import "../../styles/AddressBook.css";

// ── Icons ─────────────────────────────────────────────
const PlusIcon    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const EditIcon    = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const TrashIcon   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>;
const CloseIcon   = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const MapPinIcon  = () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#d5c9bf" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61 3.95 5.32 5.64 3.64C7.32 1.95 9.61 1 12 1C14.39 1 16.68 1.95 18.36 3.64C20.05 5.32 21 7.61 21 10Z"/><circle cx="12" cy="10" r="3"/></svg>;
const ChevronIcon = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>;
const HomeIcon    = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
const OfficeIcon  = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>;
const OtherIcon   = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;

const Spinner = ({ size = 14, color = "#E67E42" }) => (
  <span style={{
    display: "inline-block", width: size, height: size,
    border: `2px solid ${color}33`, borderTopColor: color,
    borderRadius: "50%", animation: "ab-spin 0.65s linear infinite", flexShrink: 0,
  }}/>
);

// ── Country / Province data ────────────────────────────
const COUNTRY_DATA = {
  "Philippines": ["Abra","Agusan del Norte","Agusan del Sur","Aklan","Albay","Antique","Apayao","Aurora","Basilan","Bataan","Batanes","Batangas","Benguet","Biliran","Bohol","Bukidnon","Bulacan","Cagayan","Camarines Norte","Camarines Sur","Camiguin","Capiz","Catanduanes","Cavite","Cebu","Cotabato","Davao de Oro","Davao del Norte","Davao del Sur","Davao Occidental","Davao Oriental","Dinagat Islands","Eastern Samar","Guimaras","Ifugao","Ilocos Norte","Ilocos Sur","Iloilo","Isabela","Kalinga","La Union","Laguna","Lanao del Norte","Lanao del Sur","Leyte","Maguindanao","Marinduque","Masbate","Metro Manila","Misamis Occidental","Misamis Oriental","Mountain Province","Negros Occidental","Negros Oriental","Northern Samar","Nueva Ecija","Nueva Vizcaya","Occidental Mindoro","Oriental Mindoro","Palawan","Pampanga","Pangasinan","Quezon","Quirino","Rizal","Romblon","Samar","Sarangani","Siquijor","Sorsogon","South Cotabato","Southern Leyte","Sultan Kudarat","Sulu","Surigao del Norte","Surigao del Sur","Tarlac","Tawi-Tawi","Zambales","Zamboanga del Norte","Zamboanga del Sur","Zamboanga Sibugay"],
  "United States": ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"],
  "United Kingdom": ["England","Scotland","Wales","Northern Ireland"],
  "Canada": ["Alberta","British Columbia","Manitoba","New Brunswick","Newfoundland and Labrador","Northwest Territories","Nova Scotia","Nunavut","Ontario","Prince Edward Island","Quebec","Saskatchewan","Yukon"],
  "Australia": ["Australian Capital Territory","New South Wales","Northern Territory","Queensland","South Australia","Tasmania","Victoria","Western Australia"],
  "India": ["Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat","Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab","Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Delhi","Jammu and Kashmir","Ladakh","Puducherry"],
  "Singapore": ["Central Region","East Region","North Region","North-East Region","West Region"],
  "Malaysia": ["Johor","Kedah","Kelantan","Kuala Lumpur","Labuan","Melaka","Negeri Sembilan","Pahang","Penang","Perak","Perlis","Putrajaya","Sabah","Sarawak","Selangor","Terengganu"],
  "Japan": ["Hokkaido","Aomori","Iwate","Miyagi","Akita","Yamagata","Fukushima","Ibaraki","Tochigi","Gunma","Saitama","Chiba","Tokyo","Kanagawa","Niigata","Toyama","Ishikawa","Fukui","Yamanashi","Nagano","Gifu","Shizuoka","Aichi","Mie","Shiga","Kyoto","Osaka","Hyogo","Nara","Wakayama","Tottori","Shimane","Okayama","Hiroshima","Yamaguchi","Tokushima","Kagawa","Ehime","Kochi","Fukuoka","Saga","Nagasaki","Kumamoto","Oita","Miyazaki","Kagoshima","Okinawa"],
  "China": ["Beijing","Tianjin","Shanghai","Chongqing","Guangdong","Zhejiang","Jiangsu","Shandong","Henan","Sichuan","Hubei","Hunan","Anhui","Fujian","Liaoning","Heilongjiang","Jilin","Shanxi","Shaanxi","Guizhou","Yunnan","Jiangxi","Guangxi","Inner Mongolia","Tibet","Xinjiang","Ningxia","Qinghai","Hainan"],
  "Germany": ["Baden-Württemberg","Bavaria","Berlin","Brandenburg","Bremen","Hamburg","Hesse","Lower Saxony","Mecklenburg-Vorpommern","North Rhine-Westphalia","Rhineland-Palatinate","Saarland","Saxony","Saxony-Anhalt","Schleswig-Holstein","Thuringia"],
  "France": ["Auvergne-Rhône-Alpes","Bourgogne-Franche-Comté","Bretagne","Centre-Val de Loire","Corse","Grand Est","Hauts-de-France","Île-de-France","Normandie","Nouvelle-Aquitaine","Occitanie","Pays de la Loire","Provence-Alpes-Côte d'Azur"],
  "Brazil": ["Acre","Alagoas","Amapá","Amazonas","Bahia","Ceará","Distrito Federal","Espírito Santo","Goiás","Maranhão","Mato Grosso","Mato Grosso do Sul","Minas Gerais","Pará","Paraíba","Paraná","Pernambuco","Piauí","Rio de Janeiro","Rio Grande do Norte","Rio Grande do Sul","Rondônia","Roraima","Santa Catarina","São Paulo","Sergipe","Tocantins"],
  "South Korea": ["Seoul","Busan","Incheon","Daegu","Daejeon","Gwangju","Ulsan","Sejong","Gyeonggi","Gangwon","North Chungcheong","South Chungcheong","North Jeolla","South Jeolla","North Gyeongsang","South Gyeongsang","Jeju"],
  "Indonesia": ["Aceh","Bali","Bangka Belitung","Banten","Bengkulu","Central Java","Central Kalimantan","Central Sulawesi","East Java","East Kalimantan","East Nusa Tenggara","Gorontalo","Jakarta","Jambi","Lampung","Maluku","North Kalimantan","North Maluku","North Sulawesi","North Sumatra","Papua","Riau","Riau Islands","Southeast Sulawesi","South Kalimantan","South Sulawesi","South Sumatra","West Java","West Kalimantan","West Nusa Tenggara","West Papua","West Sulawesi","West Sumatra","Yogyakarta"],
  "Thailand": ["Bangkok","Chiang Mai","Chiang Rai","Chonburi","Nakhon Ratchasima","Khon Kaen","Udon Thani","Nonthaburi","Pathum Thani","Samut Prakan","Songkhla","Surat Thani","Ubon Ratchathani","Nakhon Si Thammarat","Rayong","Phuket","Krabi","Kanchanaburi","Phitsanulok","Lampang"],
  "Vietnam": ["An Giang","Bà Rịa–Vũng Tàu","Bắc Giang","Bắc Kạn","Bạc Liêu","Bắc Ninh","Bến Tre","Bình Định","Bình Dương","Bình Phước","Bình Thuận","Cà Mau","Cần Thơ","Cao Bằng","Đà Nẵng","Đắk Lắk","Đắk Nông","Điện Biên","Đồng Nai","Đồng Tháp","Gia Lai","Hà Giang","Hà Nam","Hà Nội","Hà Tĩnh","Hải Dương","Hải Phòng","Hậu Giang","Hòa Bình","Hưng Yên","Khánh Hòa","Kiên Giang","Kon Tum","Lai Châu","Lâm Đồng","Lạng Sơn","Lào Cai","Long An","Nam Định","Nghệ An","Ninh Bình","Ninh Thuận","Phú Thọ","Phú Yên","Quảng Bình","Quảng Nam","Quảng Ngãi","Quảng Ninh","Quảng Trị","Sóc Trăng","Sơn La","Tây Ninh","Thái Bình","Thái Nguyên","Thanh Hóa","Thừa Thiên Huế","Tiền Giang","TP. Hồ Chí Minh","Trà Vinh","Tuyên Quang","Vĩnh Long","Vĩnh Phúc","Yên Bái"],
  "United Arab Emirates": ["Abu Dhabi","Dubai","Sharjah","Ajman","Umm Al Quwain","Ras Al Khaimah","Fujairah"],
  "Saudi Arabia": ["Riyadh","Mecca","Medina","Eastern Province","Asir","Tabuk","Hail","Northern Borders","Jazan","Najran","Al Bahah","Al Jawf","Qassim"],
  "Nepal": ["Bagmati","Gandaki","Karnali","Koshi","Lumbini","Madhesh","Sudurpashchim"],
  "Other": [],
};

const COUNTRIES = Object.keys(COUNTRY_DATA).sort((a, b) => {
  if (a === "Philippines") return -1;
  if (b === "Philippines") return 1;
  if (a === "Other") return 1;
  if (b === "Other") return -1;
  return a.localeCompare(b);
});

const EMPTY_FORM = {
  type: "home", address_line1: "", address_line2: "",
  city: "", province: "", zip_code: "", country: "",
};

const TYPE_META = {
  home:   { label: "Home",   Icon: HomeIcon },
  office: { label: "Office", Icon: OfficeIcon },
  other:  { label: "Other",  Icon: OtherIcon },
};

// ── Portal-based Select ────────────────────────────────
// Renders dropdown into document.body so modal overflow:auto never clips it
function SelectField({ label, value, onChange, options, placeholder, required, disabled }) {
  const [open, setOpen]               = useState(false);
  const [dropStyle, setDropStyle]     = useState({});
  const triggerRef                    = React.useRef(null);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (triggerRef.current && !triggerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Position dropdown relative to trigger on open
  useEffect(() => {
    if (!open || !triggerRef.current) return;
    const rect       = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const dropH      = 214;
    const openUp     = spaceBelow < dropH + 16 && spaceAbove > spaceBelow;

    setDropStyle({
      position : "fixed",
      left     : rect.left,
      width    : rect.width,
      zIndex   : 9999,
      ...(openUp
        ? { bottom: window.innerHeight - rect.top + 6 }
        : { top: rect.bottom + 6 }),
    });
  }, [open]);

  const displayLabel = options.includes(value) ? value : null;

  return (
    <div className="ab-field" ref={triggerRef}>
      <label className="ab-label">
        {label}{required && <span className="ab-req"> *</span>}
      </label>

      {/* Trigger button */}
      <div
        className={`ab-select ${open ? "open" : ""} ${disabled ? "disabled" : ""}`}
        onClick={() => !disabled && setOpen(v => !v)}
      >
        <span className={`ab-select-value ${!displayLabel ? "placeholder" : ""}`}>
          {displayLabel || placeholder}
        </span>
        <span className="ab-select-chevron"><ChevronIcon/></span>
      </div>

      {/* Portal dropdown — escapes modal overflow */}
      {open && ReactDOM.createPortal(
        <div className="ab-select-dropdown" style={dropStyle}>
          {options.map((opt) => (
            <div
              key={opt}
              className={`ab-select-option ${value === opt ? "active" : ""}`}
              onMouseDown={(e) => { e.preventDefault(); onChange(opt); setOpen(false); }}
            >
              {opt}
            </div>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
}

// ── Main Component ─────────────────────────────────────
export default function AddressBook() {
  const [addresses, setAddresses]           = useState([]);
  const [loading, setLoading]               = useState(true);
  const [showModal, setShowModal]           = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [formData, setFormData]             = useState(EMPTY_FORM);
  const [submitting, setSubmitting]         = useState(false);
  const [deletingId, setDeletingId]         = useState(null);

  useEffect(() => { fetchAddresses(); }, []);

  const fetchAddresses = async () => {
    try {
      setLoading(true);
      const response = await getAddresses();
      const data = response?.data?.data || response?.data || [];
      setAddresses(Array.isArray(data) ? data : []);
    } catch {
      toast.error("Failed to load addresses.");
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  };

  const openAdd = () => { setEditingAddress(null); setFormData(EMPTY_FORM); setShowModal(true); };

  const openEdit = (address) => {
    setEditingAddress(address);
    setFormData({
      type:          address.type || "home",
      address_line1: address.address_line1 || "",
      address_line2: address.address_line2 || "",
      city:          address.city || "",
      province:      address.province || "",
      zip_code:      address.zip_code || "",
      country:       address.country || address.Country || "",
    });
    setShowModal(true);
  };

  const closeModal = () => { setShowModal(false); setEditingAddress(null); setFormData(EMPTY_FORM); };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this address?")) return;
    try {
      setDeletingId(id);
      await deleteAddress(id);
      toast.success("Address deleted.");
      setAddresses((p) => p.filter((a) => a.id !== id));
    } catch {
      toast.error("Failed to delete address.");
    } finally {
      setDeletingId(null);
    }
  };

  const setField = (name, value) => {
    setFormData((p) => {
      const next = { ...p, [name]: value };
      if (name === "country") {
        const provinces = COUNTRY_DATA[value] || [];
        if (!provinces.includes(p.province)) next.province = "";
      }
      return next;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.address_line1 || !formData.city || !formData.country) {
      toast.error("Street address, city and country are required.");
      return;
    }
    try {
      setSubmitting(true);
      if (editingAddress) {
        await updateAddress(editingAddress.id, formData);
        toast.success("Address updated!");
      } else {
        await createAddress(formData);
        toast.success("Address added!");
      }
      closeModal();
      fetchAddresses();
    } catch (err) {
      toast.error(err?.response?.data?.message || `Failed to ${editingAddress ? "update" : "add"} address.`);
    } finally {
      setSubmitting(false);
    }
  };

  const buildAddressLine = (addr) =>
    [addr.address_line1 || addr.street_address || addr.address, addr.address_line2].filter(Boolean).join(", ") || "—";

  const buildCityLine = (addr) =>
    [addr.city, addr.province || addr.state, addr.zip_code || addr.postal_code, addr.country || addr.Country].filter(Boolean).join(", ") || "—";

  const provinces = COUNTRY_DATA[formData.country] || [];

  return (
    <div className="ab-root">

      <div className="acc-head">
        <div>
          <h1 className="acc-h1">Address Book</h1>
          {!loading && addresses.length > 0 && (
            <p className="ab-count">{addresses.length} saved address{addresses.length !== 1 ? "es" : ""}</p>
          )}
        </div>
        <button className="acc-btn" onClick={openAdd}><PlusIcon /> Add Address</button>
      </div>

      {loading ? (
        <div className="acc-box ab-loading-box"><Spinner size={28}/><span>Loading addresses…</span></div>
      ) : addresses.length === 0 ? (
        <div className="acc-box ab-empty-box">
          <MapPinIcon/>
          <div className="ab-empty-title">No addresses saved</div>
          <div className="ab-empty-sub">Add a delivery address to get started.</div>
          <button className="acc-btn" onClick={openAdd}><PlusIcon/> Add Address</button>
        </div>
      ) : (
        <div className="ab-grid">
          {addresses.map((addr, i) => {
            const typeKey    = (addr.type || addr.label || addr.address_type || "other").toLowerCase();
            const meta       = TYPE_META[typeKey] || TYPE_META.other;
            const isDeleting = deletingId === addr.id;
            return (
              <div key={addr.id} className="ab-card" style={{ animationDelay: `${i * 45}ms` }}>
                <div className="ab-card-badge"><meta.Icon/><span>{meta.label}</span></div>
                <div className="ab-card-body">
                  <div className="ab-address-main">{buildAddressLine(addr)}</div>
                  <div className="ab-address-city">{buildCityLine(addr)}</div>
                </div>
                <div className="ab-card-actions">
                  <button className="ab-edit-btn" onClick={() => openEdit(addr)}><EditIcon/> Edit</button>
                  <button className="ab-delete-btn" onClick={() => handleDelete(addr.id)} disabled={isDeleting}>
                    {isDeleting ? <Spinner size={12} color="#e05252"/> : <TrashIcon/>}
                    {isDeleting ? "Deleting…" : "Delete"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showModal && (
        <div className="ab-modal-overlay" onClick={closeModal}>
          <div className="ab-modal" onClick={(e) => e.stopPropagation()}>

            <div className="ab-modal-header">
              <h2 className="ab-modal-title">{editingAddress ? "Edit Address" : "Add New Address"}</h2>
              <button className="ab-modal-close" onClick={closeModal}><CloseIcon/></button>
            </div>

            <form className="ab-form" onSubmit={handleSubmit}>

              {/* Address Type */}
              <div className="ab-field ab-full">
                <label className="ab-label">Address Type</label>
                <div className="ab-type-tabs">
                  {Object.entries(TYPE_META).map(([val, { label, Icon }]) => (
                    <button key={val} type="button"
                      className={`ab-type-tab ${formData.type === val ? "active" : ""}`}
                      onClick={() => setField("type", val)}>
                      <Icon/> {label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Street Address */}
              <div className="ab-field ab-full">
                <label className="ab-label">Street Address <span className="ab-req">*</span></label>
                <input className="ab-input" value={formData.address_line1}
                  onChange={(e) => setField("address_line1", e.target.value)}
                  placeholder="123 Main Street" required/>
              </div>

              {/* Address Line 2 */}
              <div className="ab-field ab-full">
                <label className="ab-label">Address Line 2 <span className="ab-opt">(optional)</span></label>
                <input className="ab-input" value={formData.address_line2}
                  onChange={(e) => setField("address_line2", e.target.value)}
                  placeholder="Apartment, suite, floor…"/>
              </div>

              {/* Country — full width, always before province */}
              <div className="ab-full">
                <SelectField
                  label="Country"
                  value={formData.country}
                  onChange={(v) => setField("country", v)}
                  options={COUNTRIES}
                  placeholder="Select country…"
                  required
                />
              </div>

              {/* Province — dropdown if known, text input if not */}
              {provinces.length > 0 ? (
                <SelectField
                  label="Province / State"
                  value={formData.province}
                  onChange={(v) => setField("province", v)}
                  options={provinces}
                  placeholder={formData.country ? "Select province…" : "Select country first"}
                  disabled={!formData.country}
                />
              ) : (
                <div className="ab-field">
                  <label className="ab-label">Province / State</label>
                  <input className="ab-input" value={formData.province}
                    onChange={(e) => setField("province", e.target.value)}
                    placeholder="Province / State"/>
                </div>
              )}

              {/* City */}
              <div className="ab-field">
                <label className="ab-label">City <span className="ab-req">*</span></label>
                <input className="ab-input" value={formData.city}
                  onChange={(e) => setField("city", e.target.value)}
                  placeholder="City" required/>
              </div>

              {/* ZIP */}
              <div className="ab-field">
                <label className="ab-label">ZIP / Postal Code</label>
                <input className="ab-input" value={formData.zip_code}
                  onChange={(e) => setField("zip_code", e.target.value)}
                  placeholder="12345"/>
              </div>

              <div className="ab-form-actions">
                <button type="button" className="ab-cancel-btn" onClick={closeModal}>Cancel</button>
                <button type="submit" className="acc-btn" disabled={submitting}>
                  {submitting ? <><Spinner size={12}/>&nbsp;Saving…</> : editingAddress ? "Update Address" : "Save Address"}
                </button>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}